import gsap from 'gsap';

import { Elements } from './Elements';
// Define a type for the parameter
export class GenericModals {
  elements: Elements = new Elements();
  private activeModal: HTMLElement | null = null;
  initialDisplayMap = new Map<HTMLElement, string>(); // Map to store initial display properties

  public init(): void {
    console.log('GenericModals init');
    const modals = this.elements.getAll('genericModal');

    // Check if there are no modals
    if (modals.length === 0) {
      // Exit the function early if no modals are found
      return;
    }

    // Continue with the rest of the initialization if modals are found
    modals.forEach((modal) => {
      if (modal instanceof HTMLElement) {
        this.initialDisplayMap.set(modal, getComputedStyle(modal).display);

        gsap.set(modal, {
          autoAlpha: 0,
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 9999,
        });
        const b = document.querySelector('.generic_modal-back') as HTMLElement;
        if (b) {
          b.style.display = 'block';
        }
        // check if it auto popups
        const isAutoPopup = modal.attributes.getNamedItem('cc-auto-popup')?.value;
        const doCookie = modal.attributes.getNamedItem('cc-no-cookie')?.value;

        if (isAutoPopup) {
          setTimeout(() => {
            console.log('Do not do Cookie', doCookie);
            if (doCookie !== 'true') {
              const modalDisplayed = sessionStorage.getItem('modalDisplayed');
              console.log('modalDisplayed', modalDisplayed);
              if (modalDisplayed) {
                return;
              }
              sessionStorage.setItem('modalDisplayed', 'true');
            }
            this.openModal(modal);

            // this.handleOpenModalClick({ target: modal });
            // this.openAutoPopup(modal);
          }, isAutoPopup as unknown as number);
        }
      }
    });

    this.setupEventListeners();
  }
  private toggleFullScreen(): void {
    if (this.isMobileDevice()) {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    }
  }
  private isMobileDevice(): boolean {
    // Simple check based on screen width, or use a more sophisticated method if needed
    return window.innerWidth <= 479; // 768px is a common breakpoint for mobile devices
  }

  private setupEventListeners(): void {
    const openModalElements = this.elements.getAll('openGenericModal');
    openModalElements.forEach((button) => {
      button.addEventListener('click', this.handleOpenModalClick.bind(this));
    });

    const closeModalElements = this.elements.getAll('closeGenericModal');
    closeModalElements.forEach((button) => {
      button.addEventListener('click', this.handleCloseModalClick.bind(this));
    });
  }

  private handleOpenModalClick(e: Event): void {
    e.preventDefault();
    try {
      const _target = e.target as HTMLElement;
      const modalTargetName = _target.attributes.getNamedItem('cc-modal-target')?.value;

      if (!modalTargetName) {
        throw new Error('Modal target name is not defined');
      }

      const modalTarget = document.querySelector(`[cc-name="${modalTargetName}"]`) as HTMLElement;

      if (!modalTarget) {
        throw new Error(`Modal target not found for name: ${modalTargetName}`);
      }

      this.openModal(modalTarget);
    } catch (error) {
      console.error(error);
      // You can also implement additional error handling logic here,
      // such as displaying a user-friendly error message.
    }
  }

  private openModal(modalTarget: HTMLElement): void {
    // Close currently active modal if it's not the same as the new one
    if (this.activeModal && this.activeModal !== modalTarget) {
      this.closeModal(this.activeModal);
    }

    this.activeModal = modalTarget;
    const initialDisplay = this.initialDisplayMap.get(modalTarget) || 'none';

    gsap.to(modalTarget, {
      autoAlpha: 1,
      display: initialDisplay,
      duration: 0,
      ease: 'power4.inOut',
      onComplete: () => {
        // Dispatch a 'modalOpened' event after the animation completes
        const event = new CustomEvent('modalOpened', { detail: modalTarget });
        modalTarget.dispatchEvent(event);
      },
    });
    gsap.set(document.body, { overflow: 'hidden', height: '100vh' }); // Prevent scrolling
  }
  private handleCloseModalClick(e: Event): void {
    e.preventDefault();
    //this.toggleFullScreen();
    // Dispatch a 'modalClosing' event before the animation starts
    const event = new CustomEvent('modalClosing', { detail: this.activeModal });
    this.activeModal?.dispatchEvent(event);
    const _target = e.target as HTMLElement;
    const modalTarget = _target.closest('[cc-name]');
    gsap.to(modalTarget, {
      autoAlpha: 0,
      display: 'none',
      duration: 0.3,
      ease: 'power4.inOut',
    });
    gsap.set(document.body, { overflow: 'auto', height: 'auto' }); // Allow scrolling
  }
  // Additional method to close a modal
  private closeModal(modal: HTMLElement): void {
    gsap.to(modal, {
      autoAlpha: 0,
      display: 'none',
      duration: 0,
      ease: 'power4.inOut',
    });
  }
}
